import { BASE_MODULE_NAME } from '../base_module_name';
import MwChartNSeriesLine from './index';

export default angular.module(`${BASE_MODULE_NAME}.${MwChartNSeriesLine.componentName}`, [])
    .component(
        MwChartNSeriesLine.componentName,
        MwChartNSeriesLine.config
    );
